<template>
    <header class="bg-primary py-4 mb-3">
        <div class="container h-90">
            <div class="row h-100 align-items-center">
                <div class="col-lg-12">
                    <h2 class="display-4 text-white mt-5 mb-2">{{ title }}</h2>
                    <p v-if="underline" class="lead mb-2 text-white-50">{{ underline }}</p>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "topheader",

        props: {
            title: {
                type: String,
                required: true
            },
            underline: {
                type: String,
                required: false
            }

        }
    }
</script>

<style scoped>

</style>